export const API_PATH = 'https://coust.442.hk/';
export const CLIENT_PATH = 'https://coust.github.io/';
